<template>
  <div class="line-statuses">
    <div class="line-statuses-bar">
      <div
        class="line-statuses-bar__item"
        v-for="(status, index) in statuses"
        :key="index"
        :style="{ width: (status.qtd_pedidos * 100) / total + '%' }"
      >
        <span 
          class="line-statuses-bar__item--color"
          :style="{ backgroundColor: setColor(status.status) }"
          :title="status.statusDescription + ': ' + ((status.qtd_pedidos * 100) / total).toFixed() + '%'"
          v-b-tooltip.hover.top>
          {{((status.qtd_pedidos * 100) / total).toFixed() }}%
        </span>
      </div>
    </div>

    <div class="line-statuses__status-name">
      <div class="line-statuses__status-name--content" v-for="(status, index) in statuses" :key="index">
        <span class="line-statuses__status-name--color" :style="{ backgroundColor: setColor(status.status) }"></span>
        {{ status.statusDescription }} - {{ status.valor_vendido | numberToReal }}
      </div>
    </div>
  </div>
</template>

<script>
import { setColor } from "@/utils/status";
import { numberToReal } from "../../utils/money";
export default {
  props: ["statuses", "total"],
  filters: {
    numberToReal
  },
  methods: {
    setColor
  }
};
</script>

<style lang="scss" scoped>
.line-statuses {
  margin: 40px 0;
  &__status-name {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    gap: 0 2rem;
    &--content {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      gap: .4rem;
      line-height: 19px;
      &:not(:last-child) {
        margin-bottom: 25px;
      }
    }
    &--color {
      background-color: #2c2c2c;
      min-width: 15px;
      min-height: 15px;
      border-radius: 50%;
    }
  }
}

.line-statuses-bar {
  display: flex;
  &__item {
    border: .5px solid white;
    min-width: 42px;
    // flex: 1;
    &:first-child {
      > span {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
    &:last-child {
      > span {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
    &--status {
      font-size: 16px;
      color: #2c2c2c;
      text-align: center;
      border-right: 1px solid #aaaaaa;
    }
    &--color {
      background-color: #2c2c2c;
      height: 30px;
      width: 100%;
      display: inline-flex;
      margin-bottom: 15px;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: white;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
